import {
	LB_REONBOARDING_GAP_MS,
	lbReOnboardingAnchorKey,
	onboardingHints,
	routes,
} from '../../constants';
import { safeLocalStorage } from '../../utils/safeStorage';
import useIsLBUser from '../../utils/useIsLBUser';
import useOnboardingDialog from '../../utils/useOnboardingDialog';
import useRouter from '../../utils/useRouter';

const hasReOnboardingGapElapsed = (): boolean => {
	const anchor = safeLocalStorage.getItem(lbReOnboardingAnchorKey);
	const ts = Number(anchor);
	if (!anchor || !Number.isFinite(ts)) return false;
	return Date.now() - ts >= LB_REONBOARDING_GAP_MS;
};

// Shared with the school-admin hint, which waits while this dialog is due.
const useShouldShowLBReOnboardingDialog = (): boolean => {
	const isLBUser = useIsLBUser();
	const { isShown } = useOnboardingDialog(onboardingHints.lbReOnboardingDialog);
	const { match } = useRouter();
	const isOnDashboard = match.location.pathname.startsWith(`/${routes.dashboard.root}`);

	return isLBUser && isOnDashboard && !isShown && hasReOnboardingGapElapsed();
};

export default useShouldShowLBReOnboardingDialog;
